import businessHelper from "./BusinessHelper";

const groupHelpers = {
    groups: function () {
        return (businessHelper.business().student_ranks || []).sort((a, b) => a.position - b.position)
    }

};

export default groupHelpers;